var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73999 6.54L13.24 1.31",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09 0.5L13.24 1.31L12.44 3.46",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.51H11.25V6.51001C11.25 6.3774 11.3027 6.25022 11.3964 6.15646C11.4902 6.06269 11.6174 6.01001 11.75 6.01001H13.25C13.3826 6.01001 13.5098 6.06269 13.6036 6.15646C13.6973 6.25022 13.75 6.3774 13.75 6.51001V13.51Z",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.51H6.25L6.25 8.01001C6.25 7.8774 6.30268 7.75022 6.39645 7.65646C6.49021 7.56269 6.61739 7.51001 6.75 7.51001H8.25C8.38261 7.51001 8.50979 7.56269 8.60355 7.65646C8.69732 7.75022 8.75 7.8774 8.75 8.01001V13.51Z",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.51H1.25L1.25 9.51001C1.25 9.3774 1.30268 9.25022 1.39645 9.15646C1.49021 9.06269 1.61739 9.01001 1.75 9.01001H3.25C3.38261 9.01001 3.50979 9.06269 3.60355 9.15646C3.69732 9.25022 3.75 9.3774 3.75 9.51001L3.75 13.51Z",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.b1374f7cb105e181bb0f17fc40a842c2.svg";
export { ForwardRef as ReactComponent };